import { z } from 'zod';
import { PropertyCategorySchema } from '../common/property-taxonomy.schema';
import { TransactionTypeSchema } from '../common/transaction-type.schema';
import { EXTRACTABLE_PROPERTY_FIELD_KEYS } from './extractable-field-keys';

/** Objekt fields a catalog key may point to read-only (IMM-1439, Refined Decision 1). Never extracted, never promoted. */
export const LINKED_PROPERTY_FIELD_KEYS = [
  'amenities.FLOORING_TYPE',
  'amenities.GUEST_TOILET',
  'amenities.LAN_CABLING',
  'amenities.NUMBER_OF_BALCONIES',
  'amenities.CELLAR_STATE',
  'amenities.BARRIER_FREE',
  'amenities.LIFT',
  'amenities.BUILT_IN_KITCHEN',
  'amenities.GARDEN',
  'amenities.PARKING_SPACES',
  'amenities.PARKING_SPACE_TYPE',
  'amenities.PETS_POLICY',
  'amenities.LISTED_MONUMENT',
  'areas.BALCONY_AREA',
  'areas.HALL_AREA',
  'energy.firingType',
  'energy.heatingType',
  'identity.subtype',
  'identity.commercialFineType',
  'identity.availableFrom',
  'distances.entries',
  'additionalCosts.entries',
  'plotDetails.requiresDemolition',
  'plotDetails.hasBuildingPermission',
  'plotDetails.siteConstructibleType',
  'investmentYield.isRented',
  'investmentYield.numberOfVacancies',
  'investmentYield.rentalIncomeActual',
  'investmentYield.rentalIncomeTarget',
  'investmentYield.walt',
  'investmentYield.numberOfApartments',
  'investmentYield.numberOfCommercialUnits',
  'rentalTerms.rentType',
  'rentalTerms.fixedTermUntil',
  'pricingRental.heatingCosts',
  'pricingRental.ancillaryCosts',
  'pricingRental.ancillaryCostsType',
  'pricingRental.priceOnInquiry',
  'pricingRental.commission',
  'pricingRental.parkingRent',
  'pricingSale.hasCommission',
  'pricingSale.commissionNote',
  'pricingSale.commissionRateNet',
  'pricingSale.priceOnInquiry',
] as const;

export const PROPERTY_FIELD_LINK_KEYS = [...EXTRACTABLE_PROPERTY_FIELD_KEYS, ...LINKED_PROPERTY_FIELD_KEYS] as const;
export const PropertyFieldLinkKeySchema = z.enum(PROPERTY_FIELD_LINK_KEYS);

export const PropertyFieldLinkOverrideSchema = z.object({
  marketingType: TransactionTypeSchema.nullable(),
  category: PropertyCategorySchema.nullable(),
  propertyFieldKey: PropertyFieldLinkKeySchema,
});

export type LinkedPropertyFieldKey = (typeof LINKED_PROPERTY_FIELD_KEYS)[number];
export type PropertyFieldLinkKey = z.infer<typeof PropertyFieldLinkKeySchema>;
export type PropertyFieldLinkOverride = z.infer<typeof PropertyFieldLinkOverrideSchema>;
